import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-gray-500 text-sm" }
const _hoisted_2 = { class: "flex flex-row items-baseline" }
const _hoisted_3 = { class: "text-xl text-gray-700" }
const _hoisted_4 = { class: "text-sm text-gray-500 flex flex-row items-baseline ml-2 space-x-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowDownIcon = _resolveComponent("ArrowDownIcon")
  const _component_ArrowUpIcon = _resolveComponent("ArrowUpIcon")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    default: _withCtx(() => [
      _createVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode("p", _hoisted_3, "$" + _toDisplayString(_ctx.amount), 1),
        _createVNode("p", _hoisted_4, [
          (_ctx.percentage)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (_ctx.percentage < 0)
                  ? _createVNode(_component_ArrowDownIcon, {
                      key: 0,
                      class: "w-4 h-4 text-danger"
                    })
                  : _createCommentVNode("", true),
                (_ctx.percentage >= 0)
                  ? _createVNode(_component_ArrowUpIcon, {
                      key: 1,
                      class: "w-4 h-4 text-primary"
                    })
                  : _createCommentVNode("", true),
                _createVNode("span", {
                  class: {
							'text-primary': _ctx.percentage >= 0,
							'text-danger': _ctx.percentage < 0,
						}
                }, _toDisplayString(_ctx.percentage.replace('-', '')) + "% ", 3)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("", true),
          (_ctx.text)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.text), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}